export enum PrinterNetworkState {
	CHECKING = "CHECKING",
	ONLINE = "ONLINE",
	OFFLINE = "OFFLINE",
}

export interface PrinterState {
	networkState: PrinterNetworkState;
}
